import { Dispatch } from 'redux'

export const SET_FORM_LANGUAGE_RESTRICTION = 'FORM_RESTRICTIONS_SET_LANGUAGE'
export const CLEAR_FORM_LANGUAGE_RESTRICTION = 'FORM_RESTRICTIONS_CLEAR_LANGUAGE'

interface SetFormLanguageRestrictionAction {
  type: typeof SET_FORM_LANGUAGE_RESTRICTION
  data: string[]
}

interface ClearFormLanguageRestrictionAction {
  type: typeof CLEAR_FORM_LANGUAGE_RESTRICTION
}

export type FormRestrictionsAction =
  | SetFormLanguageRestrictionAction
  | ClearFormLanguageRestrictionAction

export function setFormLanguageRestriction (allowedLanguages: string[]) {
  return (dispatch: Dispatch<FormRestrictionsAction>) => {
    dispatch({
      type: SET_FORM_LANGUAGE_RESTRICTION,
      data: allowedLanguages
    })
  }
}

export function clearFormLanguageRestriction () {
  return (dispatch: Dispatch<FormRestrictionsAction>) => {
    dispatch({
      type: CLEAR_FORM_LANGUAGE_RESTRICTION
    })
  }
}
